import React, {useState} from 'react'
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, ButtonType, Card, Colors, ButtonTier} from '../index';
import { logger } from '../../utilities';
import clsx from 'clsx';
import './Modal.scss';

const LOG_PREFIX = '[CheckoutModal.js]';

const CheckoutModal = ({children, toggleClosed}) => {
  logger.debug(LOG_PREFIX, '.CheckoutModal()', { toggleClosed, children });
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className={'Modal--background'}>
      <div className={'closeArea'} onClick={toggleClosed} />
      <Card className={clsx('Modal', 'CheckoutModal')}>
        { children }
      </Card>
    </div>
  )
}

export default CheckoutModal